import { render } from "./MemberCampaignDetails.vue?vue&type=template&id=e2d95abc&scoped=true"
import script from "./MemberCampaignDetails.vue?vue&type=script&lang=js"
export * from "./MemberCampaignDetails.vue?vue&type=script&lang=js"

import "./MemberCampaignDetails.vue?vue&type=style&index=0&id=e2d95abc&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d95abc"]])

export default __exports__